import React from 'react';
import { motion } from 'framer-motion';
import { Star, TrendingUp, Quote, BadgeCheck } from 'lucide-react';
export function SuccessStoriesSection() {
  return <section className="py-20 px-4 bg-[#080808] border-y border-white/5" data-id="element-317">
      <div className="max-w-6xl mx-auto" data-id="element-318">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-319">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-yellow/10 rounded-full text-brand-yellow font-bold text-sm uppercase tracking-wider mb-6" data-id="element-320">
            <TrendingUp size={16} data-id="element-321" />
            Resultados Reales
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-322">
            Ellos empezaron con este mismo Libro Digital
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-323">
            Hoy facturan más de{' '}
            <span className="text-white font-bold" data-id="element-324">$10,000 USD al mes</span>.
            Todo empezó con una decisión de $7 y el Mapa 3×3.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-325">
          {testimonials.map((story, index) => <SuccessCard key={index} story={story} index={index} data-id="element-326" />)}
        </div>
      </div>
    </section>;
}
function SuccessCard({
  story,
  index
}: {
  story: (typeof testimonials)[0];
  index: number;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: index * 0.1
  }} className="bg-[#111] p-8 rounded-2xl border border-gray-800 relative group hover:border-brand-yellow/30 transition-colors" data-id="element-327">
      {/* Quote Icon */}
      <div className="absolute top-6 right-6 text-gray-800 group-hover:text-brand-yellow/20 transition-colors" data-id="element-328">
        <Quote size={40} data-id="element-329" />
      </div>

      {/* Stars */}
      <div className="flex gap-1 mb-6" data-id="element-330">
        {[...Array(5)].map((_, i) => <Star key={i} size={16} className="text-brand-yellow fill-brand-yellow" data-id="element-331" />)}
      </div>

      {/* Content */}
      <p className="text-gray-300 mb-8 leading-relaxed relative z-10" data-id="element-332">
        "{story.quote}"
      </p>

      {/* User Info */}
      <div className="flex items-center gap-4 border-t border-gray-800 pt-6" data-id="element-333">
        <div className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center text-xl font-bold text-gray-400" data-id="element-334">
          {story.initials}
        </div>
        <div data-id="element-335">
          <h4 className="font-bold text-white" data-id="element-336">{story.name}</h4>
          <div className="flex items-center gap-1 text-xs text-gray-500" data-id="element-337">
            <BadgeCheck size={12} className="text-brand-yellow" data-id="element-338" />
            Comprador Verificado
          </div>
        </div>
      </div>

      {/* Income Badge */}
      <div className="mt-6 bg-green-900/20 border border-green-900/50 rounded-lg p-3 flex items-center justify-between" data-id="element-339">
        <span className="text-xs text-green-400 font-medium uppercase tracking-wide" data-id="element-340">
          Ingreso Mensual
        </span>
        <span className="text-green-400 font-bold font-display text-lg" data-id="element-341">
          {story.income}
        </span>
      </div>
    </motion.div>;
}
const testimonials = [{
  name: 'Valentina S.',
  initials: 'VS',
  quote: 'Tenía miedo de que nadie me tomara en serio porque no tengo título ni experiencia. Pero resulta que sí tenía algo que ofrecer. Solo necesitaba que alguien me lo mostrara claro. El primer día que me pagaron casi lloro.',
  income: '$15,200 / mes'
}, {
  name: 'Carlos R.',
  initials: 'CR',
  quote: 'Yo no soy de tecnología ni de redes. Solo soy bueno armando cosas y resolviendo problemas. Lo que me gustó es que no tuve que inventar nada — solo seguí los pasos. A los 3 días ya tenía gente escribiéndome. Eso nunca me había pasado.',
  income: '$10,800 / mes'
}, {
  name: 'María G.',
  initials: 'MG',
  quote: 'Llevaba meses sintiéndome culpable por no aportar en casa. Siempre supe que era buena organizando y ayudando a otros, pero no sabía cómo cobrar por eso. Este libro me quitó esa duda. A la semana ya tenía mis primeros clientes y por primera vez sentí que yo también podía.',
  income: '$4,800 / mes'
}];